import { type Sensitive } from '~/composables/useMarketingMetrics';

export const createMarketingMetricsHash = () => {
    const primitive = async <T>(value: T): Promise<Sensitive<T>> => {
        const stringValue = String(value).trim().toLowerCase();
        const msgBuffer = new TextEncoder().encode(stringValue);
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

        return Array.from(new Uint8Array(hashBuffer))
            .map((byte) => byte.toString(16).padStart(2, '0'))
            .join('') as Sensitive<T>;
    };

    const object = async <T extends Object>(value: T): Promise<Sensitive<T>> => {
        const keys = Object.keys(value) as Array<keyof T>;

        const entries = await Promise.all(
            keys.map(async (key) => {
                const hashedValue = await primitive(value[key]);
                return [key, hashedValue] as const;
            })
        );

        return Object.fromEntries(entries) as Sensitive<T>;
    };

    const array = <T>(value: T[]): Promise<Sensitive<T>[]> => {
        return Promise.all(value.map((item) => primitive(item)));
    };

    return { primitive, object, array };
};
